import { CustomerContact } from '../../../types/customer-contact';

export const emptyForm = {
  item: '',
  client_id: '',
  short_name: '',
  status: 'active' as 'active' | 'inactive',
  monday_id: '',
  funding_type: '',
  client_drive_name: '',
  google_drive_url: 'https://drive.google.com/',
};

export const emptyContactForm = {
  name: '',
  email: '',
  phone: '',
  title: '',
  street: '',
  city: '',
  state: '',
  zip: '',
  country: '',
  notes: '',
  is_primary: false,
};

export const formatAddress = (contact: CustomerContact): string => {
  const parts = [
    contact.street,
    contact.city,
    contact.state,
    contact.zip,
    contact.country,
  ].filter(Boolean);
  return parts.length > 0 ? parts.join(', ') : '-';
};
